import * as Constants from "../Constants";
import { getAPIIncludeAuth } from "./Shared";

export async function getAllPharmacons() {
    const api = Constants.BACKEND_URL + Constants.API_PHARMACON + "?paginationEnabled=false";
    return getAPIIncludeAuth(api);
}
